// src/util/wakeLock.ts — Screen Wake Lock during active sessions so the phone doesn't
// sleep mid-conversation. Not a PWA feature; degrades silently where unsupported (E12).
// Typed loosely because WakeLock types are not in every TS lib version.
let sentinel: { release?: () => Promise<void> } | null = null;

export async function requestWakeLock(): Promise<void> {
  try {
    const wl = (navigator as unknown as { wakeLock?: { request(t: string): Promise<unknown> } })
      .wakeLock;
    if (!wl || sentinel) return;
    sentinel = (await wl.request("screen")) as { release?: () => Promise<void> };
    (sentinel as unknown as { addEventListener?: (t: string, cb: () => void) => void }).addEventListener?.(
      "release",
      () => {
        sentinel = null;
      }
    );
  } catch {
    sentinel = null;
  }
}

export function releaseWakeLock(): void {
  try {
    void sentinel?.release?.();
  } catch {
    /* ignore */
  }
  sentinel = null;
}
